import type { OAISchema } from '~/types/openapi';

type Props =
  | OAISchema['MarketProductDetailsResponseV2']
  | OAISchema['MarketSelectProductResponseV2'];

export function eCouponPurchaseText({
  eCouponInfo,
  eCouponOrderDisabled,
}: Props) {
  if (eCouponOrderDisabled) {
    return '포인트부족';
  }

  return eCouponInfo?.giftAllowed ? '선물하기' : '구매하기';
}
